import {BaseContainerModel} from '../base-container.model';
import {app_perm_dfn_RowClass} from '../../dbschema';

export class PermissionContainerModel extends BaseContainerModel {
  permDfn: app_perm_dfn_RowClass = new app_perm_dfn_RowClass();
}
